<div class="dialog-header-container">
    <div class="d-flex align-items-center">
        <h2 mat-dialog-title class="pd-t-5px">Task Edit</h2>
    </div>
    <div>
        <button mat-icon-button aria-label="Example icon-button with heart icon" (click)="triggerConfirm()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
<mat-divider class="mat-divider"></mat-divider>
<div mat-dialog-content  id="taskEditReassign">
    <div class="" style="margin: 10px 0px 0px 0px;">
        <div [ngClass]="'col-md-12'">
                <mat-label class="body-font-size">Task Title:</mat-label>
                <div style="outline: 1px;" class="body-font-size taskTitles" contenteditable="true" id="taskValue"
                    [innerHtml]="taskTitleInfo" (input)="check()"></div>
                <mat-divider class="mat-divider"></mat-divider>
        </div>
        <div class="d-flex col-12 mt-3">
            <div [ngClass]="'col-md-3 col-sm-4 col-xl-3'">
                <mat-form-field class="body-font-size">
                    <mat-label class="body-font-size">Assigned By:</mat-label>
                    <input matInput class="body-font-size" readonly type="text"
                        value="{{meetingInfoData.taskData.createdByName}}" />
                </mat-form-field>
            </div>
            <div [ngClass]="'col-md-3 col-sm-4 col-xl-3'">
                <mat-form-field class="body-font-size">
                    <mat-label class="body-font-size">Due Date:</mat-label>
                    <input matInput #input [matDatepicker]="picker" (dateChange)='updateDate($event)'
                        (focus)="picker.open()" class="body-font-size" readonly type="text" [(ngModel)]="dueDateInfo" />
                    <mat-datepicker (closed)="input.blur()" #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <div class="d-flex align-items-center flex-wrap"
            *ngFor="let worker of meetingInfoData.taskData.actionItemOwner; let index = index">
            <div class="col-md-3 col-sm-4 col-12">
                <mat-form-field class="body-font-size">
                    <mat-label class="body-font-size">Assigned To:</mat-label>
                    <!-- <input matInput class="body-font-size assignedToVal" id="assignedTo" type="text"  [attr.fkuserid] = "worker.fkSecUserOwner" (click) = "updateReAssign($event)"  (focus)="assignToTask(worker.fkSecUserOwner,$event.target)" value="{{worker.ownerName}}" [disabled] = "worker.ownerName != '' ? true : false"/>
                            <input class="body-font-size" type="hidden" id="attUserId" [attr.userId] = "worker.fkSecUserOwner" [(ngModel)]="worker.fkSecUserOwner" /> -->
                    <input matInput (focus)="assignToTask(index,worker.fkSecUserOwner,$event.target)"
                        [disabled]="worker.ownerName != '' ? true : false" [attr.fkuserid]="worker.fkSecUserOwner"
                        type="text" class="body-font-size Re_assignedToVal" value={{worker.ownerName}} />
                </mat-form-field>
            </div>
            <div class="col-md-3 col-sm-4 col-12">
                <mat-form-field class="body-font-size" *ngIf="worker.ownerName != ''">
                    <mat-label class="body-font-size">Re-Assigned To:</mat-label>
                    <input matInput class="body-font-size Re_assignedToVal"
                        (focus)="reassignTask(worker.fkSecUserOwner,$event.target)"
                        (blur)="reassignClear(worker.fkSecUserOwner,$event.target)"
                        id="reassignId{{worker.fkSecUserOwner}} reAssign" type="text" />
                </mat-form-field>
            </div>
            <div class="col-md-3 col-sm-3 col-12">
                <mat-form-field class="body-font-size">
                    <mat-select [disabled]="worker.ownerName == '' ? true : false" disableOptionCentering
                        panelClass="common-drop-down-class" class="body-font-size" [value]="worker.fkCodelstStatus"
                        (focus)="taskUser(worker.fkSecUserOwner)" (selectionChange)="updateTaskStatus($event)">
                        <mat-option class="body-font-size" *ngFor="let l of taskStatusList"
                            [value]="l.codeId">{{l.description}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-md-2 col-sm-1 col-12">
                <button mat-icon-button style="margin-left: 37px;" (click)="addATask()" *ngIf="index == 0">
                    <mat-icon>add</mat-icon>
                </button>
                <button mat-icon-button style="margin-left: 37px;" (click)="deleteTask(index,worker.fkSecUserOwner)"
                    *ngIf="index != 0 && length > index">
                    <mat-icon>delete</mat-icon>
                </button>
                <button mat-icon-button style="margin-left: 37px;" (click)="delete(index,worker.fkSecUserOwner)"
                    *ngIf="index >= length">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        <div style="margin-bottom: 10px">
            <mat-form-field class="body-font-size w-100">
                <mat-label>Remarks/Comments</mat-label>
                <textarea 
                    matInput
                    formControlName="remarks"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="6"
                    [formControl]="noteDescription">
                </textarea>
            </mat-form-field>
            <!-- <textarea class="text-area-container body-font-size" 
                placeholder="Remarks/Comments"></textarea> -->
        </div>
        <div class="text-align-end">
            <button mat-button class="button-container mar-r-10px primary" (click)="updateTaskPOpup()">Save</button>
            <button mat-button class="button-container primary" mat-dialog-close>Cancel</button>
        </div>
    </div>
    <mat-divider class="divider-container"></mat-divider>
    <cdk-accordion class="example-accordion">
        <cdk-accordion-item #accordionItem="cdkAccordionItem">
            <div class="example-accordion-item-header" (click)="accordionItem.toggle()">
                <span class="example-accordion-item-description">
                    <mat-icon class="acc-icon">{{accordionItem.expanded ? 'keyboard_arrow_down' :
                        'keyboard_arrow_right'}}</mat-icon>
                </span>
                <div class="accordion-header-container">
                    <div class="accordion-header-left-container">
                        <a class="accordion-title"
                            (click)="redirectToMeeting(meetingInfoData)">{{meetingInfoData.meetingData.meetingTitle}}</a>
                        <p class="body-font-size m-0" style="color: #000;padding-top: 3px;">
                            {{meetingInfoData.meetingData.meetingDateShortFormat}} at
                            {{meetingInfoData.meetingData.meetingStartTime}} for
                            {{meetingInfoData.meetingData.duration}} minutes</p>
                    </div>
                </div>
            </div>
            <div class="list-section-container d-flex flex-wrap margin-0" style="padding-left: 24px;padding-top: 5px;">
                <ng-container *ngFor="let attendeeName of meetingInfoData.meetingData.attendeeList">
                    <app-participant-view-chip [flagData]="'Y'" [participantName]="attendeeName"
                        [participantJsonData]="meetingInfoData.meetingData"></app-participant-view-chip>
                </ng-container>
            </div>
            <div class="notes-section" role="region" [style.display]="accordionItem.expanded ? '' : 'none'"
                [attr.id]="'accordion-body-' + 0" [attr.aria-labelledby]="'accordion-header-' + 0">
                <mat-list>
                    <mat-list-item style="height: auto;" class="p-0">
                        <div class="list-item-container" *ngFor="let agenda of meetingInfoData.meetingData.agendaList">
                            <div *ngIf="agenda.agendaId == meetingInfoData.taskData.agendaId"
                                class="agenda-first-section">
                                <div>
                                    <h3 class="acc-content">{{agenda.agendaTitle}}</h3>
                                </div>
                            </div>
                            <ng-container *ngIf="agenda.agendaId == meetingInfoData.taskData.agendaId">
                                <div *ngFor="let minutes of agenda.minutesList">
                                    <div class="agenda-first-section" *ngIf="minutes.entityType == 'MN'">
                                        <div style="margin-right: 10px;">
                                            <button class="mat-margin-3px global-icn-bttn-container" mat-mini-fab
                                                tooltip="Task" triggers="hover"><mat-icon
                                                    class="global-icn-size notes">notes</mat-icon></button>
                                        </div>
                                        <div>
                                            <h4 class="body-font-size" [innerHTML]="minutes.noteDescription"
                                                style="margin-top: 10px;"></h4>
                                        </div>
                                    </div>
                                    <div class="agenda-first-section" *ngIf="minutes.entityType == 'MD' ">
                                        <div style="margin-right: 10px;">
                                            <button class="mat-margin-3px global-icn-bttn-container" mat-mini-fab
                                                tooltip="Decision" triggers="hover"><mat-icon
                                                    class="global-icn-size decision">thumb_up</mat-icon></button>

                                        </div>
                                        <div>
                                            <h4 class="body-font-size" [innerHTML]="minutes.noteDescription"
                                                style="margin-top: 10px;"></h4>
                                        </div>
                                    </div>
                                    <div class="agenda-first-section"
                                        *ngIf="minutes.entityType == 'AI' && minutes.taskId != meetingInfoData.taskData.taskId ">
                                        <div style="margin-right: 10px;">
                                            <button class="mat-margin-3px global-icn-bttn-container" mat-mini-fab
                                                tooltip="Task" placement="right" triggers="hover"><mat-icon
                                                    class="global-icn-size assignment">assignment</mat-icon></button>

                                        </div>
                                        <div>
                                            <h4 class="body-font-size" [innerHTML]="minutes.taskTitle"
                                                style="margin-top: 10px;"></h4>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </mat-list-item>
                </mat-list>
            </div>
            <div class="example-accordion-item-body">
                <div class="accordion-container">
                    <div class="accordion-right-container">
                        <div class="accordion-inner-container">
                        </div>
                    </div>

                </div>
            </div>

        </cdk-accordion-item>
        <mat-divider class="divider-container"></mat-divider>
    </cdk-accordion>
</div>
